/**
 * Custom hook for accessing the raffle theme context
 */

import { useContext } from 'react';
import { RaffleThemeContext } from '@/contexts/RaffleThemeContext';

export function useRaffleTheme() {
  const context = useContext(RaffleThemeContext);
  if (!context) {
    throw new Error('useRaffleTheme must be used within RaffleThemeProvider');
  }
  return context;
}
